export default __webpack_public_path__ + "static/media/logo-symbol.714c4abd.svg";